import { Button } from "@repo/ui/components/ui/button";
import { type ErrorComponentProps, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";

export function RouteError({ error, reset }: ErrorComponentProps) {
  const router = useRouter();
  useEffect(() => {
    console.error("Provider route failed", error);
  }, [error]);

  return (
    <main className="flex min-h-svh items-center justify-center p-6">
      <div role="alert" className="w-full max-w-md space-y-4 rounded-lg border bg-card p-6 text-card-foreground">
        <h1 className="text-lg font-semibold">This page couldn't be displayed</h1>
        <p className="text-sm text-muted-foreground">An unexpected error occurred. Try loading the page again.</p>
        <Button
          onClick={async () => {
            await router.invalidate();
            reset();
          }}
        >
          Try again
        </Button>
      </div>
    </main>
  );
}
